/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Header from "../../Common/Navbar";
import { fetchApi } from "../../utlis/axios";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import Loader from "../../animation/Loader.json";
import backArrow from "../../assets/back-button.png";
import ReceiptModel from "../Receipts/ReceiptModel";
import RegisterIms from "../../RegistrationForms/RegisterIms";

const ImsDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(null);
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [isEditing, setIsEditing] = useState(false);
  const [data, setData] = useState(null);
  const [showModel, setShowModel] = useState(false);
  const medicines = [];

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await fetchApi.get(`ims-auth/${id}/`, {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });
      if (result.status === 200) {
        setData(result?.data);
      }
    } catch (error) {
      console.log({ error });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleEditSuccess = (updatedData) => {
    setData(updatedData);
    setIsEditing(false);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <>
      <Header parent="family" />
      {showModel && (
        <div className="z-10 top-0 left-0 right-0 fixed">
          <div
            className="bg-gray-900 bg-opacity-80 h-full w-full fixed"
            onClick={() => setShowModel(false)}
          />
          <ReceiptModel setShowModel={setShowModel} medicines={medicines} />
        </div>
      )}

      {/* Edit popup – RegisterIms form */}
      {isEditing && data && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div
            className="absolute inset-0 bg-black/50"
            onClick={() => setIsEditing(false)}
            aria-hidden
          />
          <div className="relative z-[200] w-full max-w-4xl max-h-[90vh] overflow-y-auto">
            <RegisterIms
              isEditMode
              initialData={data}
              storeId={id}
              userId={data?.user?.id}
              onSuccess={handleEditSuccess}
              onCancel={() => setIsEditing(false)}
            />
          </div>
        </div>
      )}

      <div
        className="min-h-screen mt-14 md:px-10 px-5 pb-10"
        style={{ backgroundColor: "#EDF7F5" }}
      >
        <button
          type="button"
          className=" w-max flex items-center gap-2 text-gray-700 hover:text-primary-green transition-colors mb-6 rounded-full"
          onClick={handleGoBack}
        >
          <img src={backArrow} alt="Back" className="w-5 h-5" />
        </button>

        <div className="max-w-4xl mx-auto">
          {isLoading ? (
            <div className="flex justify-center items-center min-h-[60vh]">
              <Lottie
                loop
                animationData={Loader}
                style={{ width: "200px" }}
                className="auth-sidebar-video"
              />
            </div>
          ) : data ? (
            <div className="space-y-6">
              {/* Page title */}
              <p className="text-sm font-medium text-primary-green uppercase tracking-wide">
                Inventory Management System
              </p>
              <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 border-l-4 border-primary-green pl-4">
                {data?.name}
              </h1>

              {/* Store details card */}
              <div className="bg-white rounded-2xl shadow-sm border border-primary-green/10 overflow-hidden">
                <div className="px-5 py-4 border-b border-primary-green/10 bg-white">
                  <h2 className="text-lg font-semibold text-primary-green">
                    Store details
                  </h2>
                </div>
                <div className="p-5 md:p-6 space-y-4">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                        Name
                      </p>
                      <p className="text-gray-800">{data?.store_name || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                        Email
                      </p>
                      <p className="text-gray-800">{data?.email || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                        Address
                      </p>
                      <p className="text-gray-800">{data?.store_address || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                        City
                      </p>
                      <p className="text-gray-800">{data?.store_city || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                        State
                      </p>
                      <p className="text-gray-800">{data?.store_state || "—"}</p>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                        Phone
                      </p>
                      <p className="text-gray-800">
                        {data?.store_phone_number || "—"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

             

              {/* Edit button */}
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={handleEditClick}
                  className="px-5 py-2.5 rounded-xl bg-primary-green text-white font-medium hover:bg-primary-green/90 transition-colors shadow-sm"
                >
                  Edit
                </button>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ImsDetails;
